import React from 'react'
import ReactDOM from 'react-dom/client'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons, registerIcons } from '@fluentui/react'

import NoPage from './pages/NoPage'

import './index.css'
import { SidebarProvider } from './state/SidebarProvider'
import { ChatProvider } from './state/ChatProvider'
import About from './pages/about/About'
import { AppStateProvider } from './state/AppProvider'
import Layout from './pages/layout/Layout'
import Chat from './pages/chat/Chat'
import { customIcons } from './utils/customIcons'

initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/')


// Register custom icons
registerIcons({
  icons: customIcons
});


export default function App() {
  return (
    <AppStateProvider>
      <SidebarProvider>
        <HashRouter>
          <ChatProvider>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Chat />} />
                <Route path="about" element={<About />} />
                <Route path="*" element={<NoPage />} />
              </Route>
            </Routes>
          </ChatProvider>
        </HashRouter>
      </SidebarProvider>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
